import {Component, Input} from '@angular/core';
import {Course} from "../../courses/shared/course";

@Component({
  selector: 'app-syllabus-recommenders',
  templateUrl: './syllabus-recommenders.component.html'
})
export class SyllabusRecommendersComponent {

  @Input() course: Course;

  constructor() { }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-recommenders/syllabus-recommenders.component.ts